import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaRupeeSign } from 'react-icons/fa';
import { GiLotusFlower } from 'react-icons/gi';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      whileHover={{ y: -8, boxShadow: '0 20px 40px rgba(212,175,55,0.25)' }}
      transition={{ duration: 0.3 }}
      onClick={() => navigate(`/products/${product._id}`)}
      style={{
        background: 'linear-gradient(145deg, #fffdf5, #fdf0d0)',
        border: '1px solid #e8c96d',
        borderRadius: '16px',
        overflow: 'hidden',
        cursor: 'pointer',
        position: 'relative',
      }}>

      {/* Image */}
      <div style={{ position: 'relative', overflow: 'hidden', height: '220px' }}>
        <motion.img
          whileHover={{ scale: 1.08 }}
          transition={{ duration: 0.4 }}
          src={product.image}
          alt={product.name}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        {!product.inStock && (
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.5)', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
          }}>
            <span style={{ color: '#fff', fontFamily: 'Cinzel', fontSize: '1.1rem' }}>Out of Stock</span>
          </div>
        )}
      </div>

      {/* Content */}
      <div style={{ padding: '1.2rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '0.4rem' }}>
          <GiLotusFlower color="#D4AF37" size={14} />
          <span style={{ color: '#8B6914', fontSize: '0.75rem', fontFamily: 'Inter', letterSpacing: '1px' }}>
            {product.category}
          </span>
        </div>
        <h3 style={{ fontFamily: 'Cinzel', fontSize: '1rem', color: '#2C1810', marginBottom: '0.5rem' }}>
          {product.name}
        </h3>
        <p style={{
          color: '#6b4c1e', fontSize: '0.9rem', fontFamily: 'Crimson Text',
          display: '-webkit-box', WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical', overflow: 'hidden', marginBottom: '1rem'
        }}>
          {product.description}
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <FaRupeeSign color="#D4AF37" size={14} />
          <span style={{ fontFamily: 'Cinzel', fontSize: '1.1rem', color: '#D4AF37', fontWeight: '600' }}>
            {product.price}
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;